//@ts-check
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Moment from 'react-moment';
import moment from 'moment';
import connect from '../core/EcrionProvider/connect';
import { Variants } from '../core/EcrionProvider/DateTimeProvider';
import withMomentTz from '../core/EcrionProvider/withMomentTz';
import MissingValue from './MissingValue';
/** @param {import('./types').DateTimeFormatter} props*/

var Details = function Details(_ref) {
  var value = _ref.value,
      timezone = _ref.timezone,
      long = _ref.long;
  if (!value) return null;
  var guess = moment.tz.guess();
  var local = timezone ? timezone : guess ? guess : null;
  return React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 1
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(React.Fragment, null, long ? React.createElement(React.Fragment, null, React.createElement(Moment, {
    date: value,
    tz: timezone,
    format: Variants['long']['date']
  }), React.createElement("span", {
    style: {
      marginLeft: 8
    }
  }), React.createElement(Moment, {
    date: value,
    tz: timezone,
    format: Variants['long']['time']
  }), React.createElement("span", {
    style: {
      marginLeft: 8
    }
  }), "(", local, ")") : React.createElement(React.Fragment, null, "Date is formatted using ", local, " timezone"))));
};
/** @param {Partial<import('./types').DateTimeFormatter>} props*/


var DateTimeFormatter = function DateTimeFormatter(_ref2) {
  var value = _ref2.value,
      fallback = _ref2.fallback,
      timezone = _ref2.timezone,
      format = _ref2.format,
      variant = _ref2.variant,
      type = _ref2.type,
      hideTooltip = _ref2.hideTooltip;
  if (!value) return fallback;
  var formatString = undefined;
  if (format) formatString = format;else if (variant && Variants[variant] && Variants[variant][type]) formatString = Variants[variant][type];
  if (hideTooltip) return React.createElement(Typography, {
    color: "inherit",
    component: "span",
    display: "inline"
  }, React.createElement(Moment, {
    date: value,
    tz: timezone,
    format: formatString
  }));
  return React.createElement(Tooltip, {
    title: React.createElement(Details, {
      value: value,
      timezone: timezone,
      long: variant === 'short'
    }),
    enterDelay: 1500,
    placement: "top"
  }, React.createElement(Typography, {
    color: "inherit",
    component: "span",
    display: "inline"
  }, React.createElement(Moment, {
    date: value,
    tz: timezone,
    format: formatString
  })));
};

DateTimeFormatter.defaultProps = {
  fallback: React.createElement(MissingValue, null),
  type: 'datetime',
  variant: 'long',
  hideTooltip: false
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var timezone = _ref3.userInfo.timezone;
  return {
    timezone: timezone
  };
};

var DateTimeFormatterMomentTz = withMomentTz(DateTimeFormatter);
export default connect(mapStateToProps)(DateTimeFormatterMomentTz);